import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import './index.css'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import * as serviceWorker from './serviceWorker'
import axios from 'axios'
import installAuthRefreshInterceptor from './utils/axiosInterceptors'

axios.defaults.withCredentials = true
installAuthRefreshInterceptor()

// Guard: cross-origin SDKs (notably PayPal) can emit opaque "Script error." events.
// CRA's runtime overlay can take over the app. We suppress only that opaque case
// on /order/:id pages, and let all other errors behave normally.
;(function installCrossOriginScriptErrorGuard() {
  if (typeof window === 'undefined') return
  // Only apply this guard for local development.
  // In production we want real errors to surface.
  try {
    if (process.env.NODE_ENV === 'production') return
    const host = String(window.location.hostname || '').toLowerCase()
    if (host !== 'localhost' && host !== '127.0.0.1') return
  } catch {
    // If we can't confidently detect env/host, do nothing.
    return
  }
  // Avoid double-registration during HMR
  if (window.__LOTUSTOR_SCRIPT_ERROR_GUARD_INSTALLED__) return
  window.__LOTUSTOR_SCRIPT_ERROR_GUARD_INSTALLED__ = true

  window.addEventListener(
    'error',
    (event) => {
      try {
        const msg = String(event?.message || '').trim()
        if (msg !== 'Script error.') return

        // Stash a flag so OrderScreen can show a recoverable message
        window.__LOTUSTOR_PAYPAL_SDK_ERROR__ = 'PayPal encountered an error. Click "Reload PayPal" and try again.'

        if (typeof event.preventDefault === 'function') event.preventDefault()
        if (typeof event.stopPropagation === 'function') event.stopPropagation()
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation()
      } catch {
        // ignore
      }
    },
    true
  )
})()

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
